import { Component, OnInit } from '@angular/core';
import { MasterDataService } from 'src/app/services/master-data.service';

@Component({
  selector: 'app-consultants-end-report',
  templateUrl: './consultants-end-report.component.html',
  styleUrls: ['./consultants-end-report.component.css']
})
export class ConsultantsEndReportComponent implements OnInit {

  consultantsEndReport=[];

  constructor(private masterDataService: MasterDataService) { }

  ngOnInit(): void {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; 
    const currentYear = currentDate.getFullYear();
    this.getConsultantsEndDetails(currentMonth,currentYear);
  }

  getConsultantsEndDetails(month: number, year: number) {
    this.masterDataService
        .getConsultantsEndDetails(month,year)
        .subscribe((res:any) => {
          this.consultantsEndReport = res;
        });
  }

}
